var map = {
	"./Avatar/game1/level1/0.png": "153a",
	"./Avatar/game1/level1/1.png": "f257",
	"./Avatar/game1/level1/2.png": "215d",
	"./Avatar/game1/level1/3.png": "0a74",
	"./Avatar/game1/level1/4.png": "8898",
	"./Avatar/game1/level1/5.png": "5c9f",
	"./Avatar/game1/level1/6.png": "87cb",
	"./Avatar/game1/level1/7.png": "82e3",
	"./Avatar/game1/level2/0.png": "a536",
	"./Avatar/game1/level2/1.png": "7f84",
	"./Avatar/game1/level2/2.png": "3e21",
	"./Avatar/game1/level2/3.png": "6ba9",
	"./Avatar/game1/level2/4.png": "205b",
	"./Avatar/game1/level2/5.png": "d85e",
	"./Avatar/game1/level2/6.png": "b0ec",
	"./Avatar/game1/level2/7.png": "13d3",
	"./Avatar/game1/level3/0.png": "015a",
	"./Avatar/game1/level3/1.png": "6487",
	"./Avatar/game1/level3/2.png": "ad4c",
	"./Avatar/game1/level3/3.png": "4c23",
	"./Avatar/game1/level3/4.png": "9830",
	"./Avatar/game1/level3/5.png": "bcb7",
	"./Avatar/game1/level3/6.png": "cc0b",
	"./Avatar/game1/level3/7.png": "736e",
	"./Avatar/game2/level1/0.png": "9370",
	"./Avatar/game2/level1/1.png": "76bb",
	"./Avatar/game2/level1/2.png": "8147",
	"./Avatar/game2/level1/3.png": "9dcb",
	"./Avatar/game2/level1/4.png": "9e0c",
	"./Avatar/game2/level1/5.png": "0c1d",
	"./Avatar/game2/level1/6.png": "8b79",
	"./Avatar/game2/level1/7.png": "96db",
	"./Avatar/game2/level2/0.png": "0deb",
	"./Avatar/game2/level2/1.png": "981a",
	"./Avatar/game2/level2/2.png": "e028",
	"./Avatar/game2/level2/3.png": "8a11",
	"./Avatar/game2/level2/4.png": "1e06",
	"./Avatar/game2/level2/5.png": "ee12",
	"./Avatar/game2/level2/6.png": "1632",
	"./Avatar/game2/level2/7.png": "4ab2",
	"./Avatar/game2/level3/0.png": "673e",
	"./Avatar/game2/level3/1.png": "a846",
	"./Avatar/game2/level3/2.png": "2c3e",
	"./Avatar/game2/level3/3.png": "7841",
	"./Avatar/game2/level3/4.png": "ee8c",
	"./Avatar/game2/level3/5.png": "a9b6",
	"./Avatar/game2/level3/6.png": "205c",
	"./Avatar/game2/level3/7.png": "29e8",
	"./Game1/Level1/1.png": "a21c",
	"./Game1/Level1/2.png": "1e18",
	"./Game1/Level1/3.png": "d5c6",
	"./Game1/Level1/4.png": "7994",
	"./Game1/Level1/5.png": "f0d4",
	"./Game1/Level1/6.png": "f193",
	"./Game1/Level1/7.png": "9912",
	"./Game1/Level1/base-0.png": "69b7",
	"./Game1/Level1/bg.png": "cf7a",
	"./Game1/Level2/1.png": "aeb8",
	"./Game1/Level2/2.png": "e05c",
	"./Game1/Level2/3.png": "5f93",
	"./Game1/Level2/4.png": "1e3c",
	"./Game1/Level2/5.png": "1ab2",
	"./Game1/Level2/6.png": "a943",
	"./Game1/Level2/7.png": "ddc5",
	"./Game1/Level2/base-0.png": "2bbb",
	"./Game1/Level2/base-1.png": "ed9f",
	"./Game1/Level2/bg.png": "3a64",
	"./Game1/Level3/1.png": "8281",
	"./Game1/Level3/2.png": "423c",
	"./Game1/Level3/3.png": "66d7",
	"./Game1/Level3/4.png": "294e",
	"./Game1/Level3/5.png": "6b17",
	"./Game1/Level3/6.png": "febb",
	"./Game1/Level3/7.png": "ff73",
	"./Game1/Level3/base-0.png": "d6eb",
	"./Game1/Level3/base-1.png": "9053",
	"./Game1/Level3/base-2.png": "39be",
	"./Game1/Level3/bg.png": "5175",
	"./Game2/Level1/1.png": "1c23",
	"./Game2/Level1/2.png": "ad14",
	"./Game2/Level1/3.png": "fe6e",
	"./Game2/Level1/4.png": "fd8b",
	"./Game2/Level1/5.png": "6e15",
	"./Game2/Level1/6.png": "8865",
	"./Game2/Level1/7.png": "4ce7",
	"./Game2/Level1/base-0.png": "2d61",
	"./Game2/Level1/bg.png": "135a",
	"./Game2/Level2/1.png": "6d70",
	"./Game2/Level2/2.png": "da9a",
	"./Game2/Level2/3.png": "c740",
	"./Game2/Level2/4.png": "883d",
	"./Game2/Level2/5.png": "e755",
	"./Game2/Level2/6.png": "15c9",
	"./Game2/Level2/7.png": "3f18",
	"./Game2/Level2/base-0.png": "604f",
	"./Game2/Level2/base-1.png": "6fda",
	"./Game2/Level2/bg.png": "818f",
	"./Game2/Level3/1.png": "d83b",
	"./Game2/Level3/2.png": "d8fa",
	"./Game2/Level3/3.png": "48c1",
	"./Game2/Level3/4.png": "0375",
	"./Game2/Level3/5.png": "d5d7",
	"./Game2/Level3/6.png": "2574",
	"./Game2/Level3/7.png": "af13",
	"./Game2/Level3/base-0.png": "91a8",
	"./Game2/Level3/base-1.png": "e1c6",
	"./Game2/Level3/base-2.png": "97e3",
	"./Game2/Level3/bg.png": "4619",
	"./collapse.png": "7862",
	"./cursor.png": "4ee6",
	"./expand.png": "a30e",
	"./lock.png": "266c",
	"./mask.png": "9915",
	"./top.png": "eb57"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "89f7";